module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-67.31f7814e.svg";